'use client';

import { motion } from 'framer-motion';
import { montserratMedium, montserratExtraBold } from '../fonts';

interface HomeSectionTitleProps {
  subtitle?: string;
  title: string;
  description?: string;
  centered?: boolean;
  containerClassName?: string;
  subtitleClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
}

export default function HomeSectionTitle({
  subtitle,
  title,
  description,
  centered = false,
  containerClassName = '',
  subtitleClassName = '',
  titleClassName = '',
  descriptionClassName = '',
}: HomeSectionTitleProps) {
  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`flex flex-col gap-2 ${centered ? 'text-center' : ''} ${containerClassName}`}
    >
      {subtitle && (
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className={`${montserratMedium.className} text-base sm:text-xl uppercase tracking-wider text-[color:var(--main-color)] ${subtitleClassName}`}
        >
          {subtitle}
        </motion.span>
      )}
      <motion.h2
        className={`${montserratExtraBold.className} ${centered ? 'section-title-center' : 'section-title'} ${titleClassName}`}
      >
        <span dangerouslySetInnerHTML={{ __html: title }} />
      </motion.h2>
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className={`${montserratMedium.className} mx-auto max-w-6xl text-xs sm:text-sm sm:text-base text-[color:var(--text-muted)] pb-8 md:pb-8 ${descriptionClassName}`}
        >
          {description}
        </motion.p>
      )}
    </motion.div>
  );
}

